import React from 'react';
import { StyleSheet, css } from 'aphrodite/no-important';
import { useTheme } from '../../theming/useTheme';
import { VrLineHeight } from '../../theming/verticalRhythm/verticalRhythm';
import { getHeaderHeight } from '../components/navigation/header/header.utils';
import { MEDIA_BREAKPOINTS } from '../../mediaQueries.const';

const componentConfigThemeKey = 'main';

interface MainTagThemeProps {
  vrLineHeight: VrLineHeight
  backgroundColor: string
}

interface MainWrapperProps {
  isSecondaryHeaderEnabled: boolean
  noPadding?: boolean
  configThemeKey?: string
}

export const MainWrapperComponent: React.FunctionComponent<MainTagThemeProps & MainWrapperProps> = ({ vrLineHeight, backgroundColor, isSecondaryHeaderEnabled, noPadding, children }) => {
  const headerHeight = getHeaderHeight(isSecondaryHeaderEnabled);
  const horizontalPadding = noPadding ? 0 : 1;
  const style = {
    backgroundColor,
    [MEDIA_BREAKPOINTS.X_LARGE]: {
      paddingBottom: `${vrLineHeight[MEDIA_BREAKPOINTS.X_LARGE]}px`,
      paddingTop: `${headerHeight + vrLineHeight[MEDIA_BREAKPOINTS.X_LARGE] / 4}px`,
      paddingLeft: `${vrLineHeight[MEDIA_BREAKPOINTS.X_LARGE] * horizontalPadding}px`,
      paddingRight: `${vrLineHeight[MEDIA_BREAKPOINTS.X_LARGE] * horizontalPadding}px`,
    },
    [MEDIA_BREAKPOINTS.LARGE]: {
      paddingBottom: `${vrLineHeight[MEDIA_BREAKPOINTS.LARGE]}px`,
      paddingTop: `${headerHeight + vrLineHeight[MEDIA_BREAKPOINTS.X_LARGE] / 4}px`,
      paddingLeft: `${vrLineHeight[MEDIA_BREAKPOINTS.LARGE] * horizontalPadding}px`,
      paddingRight: `${vrLineHeight[MEDIA_BREAKPOINTS.LARGE] * horizontalPadding}px`,
    },
    [MEDIA_BREAKPOINTS.MEDIUM]: {
      paddingBottom: `${vrLineHeight[MEDIA_BREAKPOINTS.MEDIUM]}px`,
      paddingRight: `${vrLineHeight[MEDIA_BREAKPOINTS.MEDIUM] * 0.5 * horizontalPadding}px`,
      paddingLeft: `${vrLineHeight[MEDIA_BREAKPOINTS.MEDIUM] * 0.5 * horizontalPadding}px`,
      paddingTop: `${headerHeight + vrLineHeight[MEDIA_BREAKPOINTS.X_LARGE] / 4}px`,
    },
    [MEDIA_BREAKPOINTS.SMALL]: {
      paddingBottom: `${vrLineHeight[MEDIA_BREAKPOINTS.SMALL]}px`,
      paddingRight: `${vrLineHeight[MEDIA_BREAKPOINTS.SMALL] * 0.5 * horizontalPadding}px`,
      paddingLeft: `${vrLineHeight[MEDIA_BREAKPOINTS.SMALL] * 0.5 * horizontalPadding}px`,
    },
    paddingTop: `${headerHeight + vrLineHeight[MEDIA_BREAKPOINTS.X_LARGE] / 4}px`,
  };

  return (
    <main
      className={css(StyleSheet.create({ style }).style)}
    >
      {children}
    </main>
  );
};

const mapThemeProps = (theme: MainTagThemeProps): MainTagThemeProps => ({
  vrLineHeight: theme.vrLineHeight,
  backgroundColor: theme.backgroundColor,
});

export const MainWrapper: React.FunctionComponent<MainWrapperProps> = props => {
  const { configThemeKey = componentConfigThemeKey } = props;
  const themeContext = useTheme(configThemeKey, mapThemeProps);
  return <MainWrapperComponent {...themeContext} {...props} />;
};
